import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly esNavegador: boolean;
  private iniciado = false;
  private ultimaRuta = '';

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private router: Router,
  ) {
    this.esNavegador = isPlatformBrowser(platformId);
  }

  iniciar(): void {
    if (!this.esNavegador || this.iniciado) return;
    this.iniciado = true;

    this.router.events
      .pipe(filter((evento): evento is NavigationEnd => evento instanceof NavigationEnd))
      .subscribe((evento) => this.enviarPageView(evento.urlAfterRedirects));

    // Cubre la navegación inicial si el router todavía no emitió NavigationEnd.
    setTimeout(() => this.enviarPageView(this.router.url), 0);
    document.addEventListener('click', this.onClick, true);
  }

  track(evento: string, parametros: Record<string, unknown> = {}): void {
    if (!this.esNavegador || this.esRutaInterna()) return;

    const datos = {
      page_location: window.location.href,
      page_title: document.title,
      ...parametros,
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', evento, datos);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: evento, ...datos });
  }

  private enviarPageView(ruta: string): void {
    if (!this.esNavegador || this.esRutaInterna() || ruta === this.ultimaRuta) return;
    this.ultimaRuta = ruta;

    setTimeout(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_location: window.location.href,
          page_path: ruta,
          page_title: document.title,
        });
      }
    }, 0);
  }

  private esRutaInterna(): boolean {
    return window.location.pathname.startsWith('/admin') || window.location.pathname.startsWith('/ig');
  }

  private readonly onClick = (evento: MouseEvent): void => {
    if (!this.esNavegador) return;

    const target = evento.target as Element | null;
    const enlace = target?.closest('a');
    if (!enlace) return;

    const href = enlace.getAttribute('href') || '';
    const texto = (enlace.textContent || '').trim().slice(0, 100);

    if (/wa\.me|api\.whatsapp\.com/i.test(href)) {
      this.track('whatsapp_click', { link_url: href, link_text: texto });
    } else if (/^tel:/i.test(href)) {
      this.track('phone_click', { link_url: href, link_text: texto });
    }
  };
}
